import React, {useEffect} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import {Actions as PAYMENTACTIONS} from '../../store/actions/paymentActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import PayslipSampleGenerator from '../common/PayslipSampleGenerator'


// import mcDonaldsLogo from '../assets/images/mc-donalds.png';
// import myokaLogo from '../assets/images/myoka.png';
// import skySpiritLogo from '../assets/images/sky-spirit.png';


function PricingTable({
    bundles,
    selectBundle,

}) {


  const setBundleForPayment = (credits) => {

    selectBundle(bundles && bundles.find(b => b.credits == credits))
    let element = document.getElementById("PayAndRegister")

    if (!element) element = document.getElementById("PriceCalculator")
    window.scrollTo(0, element.offsetTop)
  }

  return (

    <div id='pricing-table' className="py-16 overflow-hidden lg:py-24">
      <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-screen-xl">

        <div className="relative">
          <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl sm:leading-10">
            Payroll Software Pricing Table
          </h3>
          <p className="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-white">
            Each Buddy Credit is worth €2 when purchasing in-bundle. <br/>Additional bonus credits are awarded when purchasing larger bundles.
          </p>
        </div>

        <div className="relative mt-12 sm:mt-16 lg:mt-24">
          
          <div className="flex flex-col" style={{maxWidth: 600, margin:'auto'}}>
            <div className="-my-2 overflow-x-auto">
              <div className="py-2 align-middle inline-block min-w-full">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead>
                      <tr>
                        <th className="px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                          Bundle
                        </th>
                        <th className="px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                          Bonus Credits
                        </th>
                        <th className="px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                          Price
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      <tr>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <div className="text-sm leading-5 text-gray-500">
                            2000 Credits
                          </div>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <span className="text-sm leading-5 text-gray-500">220</span>
                          <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                            + 11%
                          </span>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap text-sm text-gray-500">
                          €4000
                          <button onClick={() => setBundleForPayment(2000)} type="button" className="bg-orange-500 border border-orange-500 rounded-md 5 py-1 text-xs leading-1 px-2 ml-2 text-white hover:bg-orange-600 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out">Buy</button>
                        </td>
                      </tr>

                      <tr>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <div className="text-sm leading-5 text-gray-500">
                            1000 Credits
                          </div>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <span className="text-sm leading-5 text-gray-500">80</span>
                          <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                            + 8%
                          </span>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap text-sm text-gray-500">
                          €2000
                          <button onClick={() => setBundleForPayment(1000)} type="button" className="bg-orange-500 border border-orange-500 rounded-md 5 py-1 text-xs leading-1 px-2 ml-2 text-white hover:bg-orange-600 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out">Buy</button>
                        </td>
                      </tr>

                      <tr>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <div className="text-sm leading-5 text-gray-500">
                            500 Credits
                          </div>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <span className="text-sm leading-5 text-gray-500">30</span>
                          <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                            + 6%
                          </span>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap text-sm text-gray-500">
                          €1000
                          <button onClick={() => setBundleForPayment(500)} type="button" className="bg-orange-500 border border-orange-500 rounded-md 5 py-1 text-xs leading-1 px-2 ml-2 text-white hover:bg-orange-600 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out">Buy</button>
                        </td>
                      </tr>

                      <tr>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <div className="text-sm leading-5 text-gray-500">
                            250 Credits
                          </div>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <span className="text-sm leading-5 text-gray-500">10</span>
                          <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                            + 4%
                          </span>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap text-sm text-gray-500">
                          €500
                          <button onClick={() => setBundleForPayment(250)} type="button" className="bg-orange-500 border border-orange-500 rounded-md 5 py-1 text-xs leading-1 px-2 ml-2 text-white hover:bg-orange-600 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out">Buy</button>
                        </td>
                      </tr>

                      <tr>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <div className="text-sm leading-5 text-gray-500">
                            100 Credits
                          </div>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap">
                          <span className="text-sm leading-5 text-gray-500">0</span>
                          <span className="px-2 ml-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                            + 0%
                          </span>
                        </td>
                        <td className="px-4 py-4 whitespace-no-wrap text-sm text-gray-500">
                          €200
                          <button onClick={() => setBundleForPayment(100)} type="button" className="bg-orange-500 border border-orange-500 rounded-md 5 py-1 text-xs leading-1 px-2 ml-2 text-white hover:bg-orange-600 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out">Buy</button>
                        </td>
                      </tr>


                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4 text-sm leading-5 text-gray-100 text-center">
            Do you need a larger bundle?
            <a href="https://calendly.com/buddy-intro/buddy-introduction-meeting" target="_blank" className="ml-3 font-medium text-white">
              Schedule an Appointment
            </a>
          </div>
        </div>
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {

    bundles: state.payment.bundles,
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  selectBundle: (bundle) => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
  
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PricingTable) 
